import components from "./components"

/**
 * Automaticlly imports all modules
 */
const requireModule = require.context(".", false, /\.store.js$/)
const modules = { ...components }

requireModule.keys().forEach((filename) => {
  // get the module name from the file name
  const moduleName = filename.replace(/(\.\/|\.store\.js)/g, "")
  modules[moduleName] =
    requireModule(filename).default || requireModule(filename)
})

export default modules
